export default "__VITE_ASSET__1f6d83e9__"